import { attr, belongsTo } from 'spraypaint';
import ApplicationRecord from './ApplicationRecord';

const OrderPackageExtra = ApplicationRecord.extend({
  static: {
    jsonapiType: 'order_package_extras',
  },
  attrs: {
    orderPackageId: attr(),
    extraId: attr(),
    extra: belongsTo(),
  },
});

export default OrderPackageExtra;
